export default {
    name: 'your-company',
    props: {
        userData: Object,
        yourCompany: Object,
        jobLevels: Array,
        jobIndustries: Array,
        departments: Array,
        loadUserData: Function
    },
    data() {
        return {

            message: null,
            messageClass: null,
            messageTimer: null,
            promoCodeDisconnected: !this.yourCompany.promoCodeSaved,

            //Rules
            promoCodeRules: [
                v => (v && /^.{3}\w{10}/g.test(v)) || 'This is not a valid promo code'
            ]
        }
    },
    computed: {
        disconnectCheckboxText() {
            return 'Disconnect my S2me account from ' + this.yourCompany.name;
        }
    },
    methods: {
        updateCompanyData() {
            let self = this,
                data = {
                    Id: self.userData.profile.sub,
                    JobLevelId: self.yourCompany.jobLevelId,
                    JobIndustryId: self.yourCompany.jobIndustryId,
                    DepartmentId: self.yourCompany.departmentId,
                    PromoCode: self.yourCompany.promoCode
                };

            if (self.yourCompany.promoCodeSaved && self.promoCodeDisconnected) {
                data.PromoCode = null;
            }

            if (!self.$refs.myCompanyForm.validate()) {
                return;
            }

            self.$state.set("loading", true);
            self.$api.saveCompanyInfo(self.userData, data, function (response) {
                let message = response.status != 200 &&
                    response.data ?
                    response.data.message : null;
                self.$state.set("loading", false);
                self.showMessage(message || 'Updating User Data failed.', 'error-message');
            }).then(function (responseData) {
                if (responseData) {
                    self.$state.set("loading", false);
                    self.loadUserData();
                    if (self.promoCodeDisconnected) {
                        self.promoCodeDisconnected = !self.promoCodeDisconnected;
                    }
                }
            });
        },

        showMessage(message, messageClass) {
            let self = this;

            self.message = message;
            self.messageClass = messageClass;

            clearTimeout(self.messageTimer);
            self.messageTimer = setTimeout(function () {
                self.clearMessage(messageClass);
            }, 3000);
        },

        clearMessage(messageClass) {
            let self = this;

            self.messageClass = messageClass + ' fade-out';

            clearTimeout(self.messageTimer);
            self.messageTimer = setTimeout(function () {
                self.message = null;
                self.messageClass = null;
            }, 700);

        }
    }
}
